import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../editors/mui/Button';

const styles = {
  buttonStyle: {
    cursor: 'default',
    minWidth: '70px',
    height: '35px',
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: '2px 0 0 2px',
    margin: 0,
    border: '1px solid #1875F0',
    zIndex: 0,
  },
  labelStyle: {
    fontSize: 10,
  },
};

class ActiveFlatButton extends Component {
  render() {
    const { label, ...otherProps } = this.props;
    return (
      <Button buttonTheme="primary" rootStyle={styles.buttonStyle} {...otherProps}>
        <span style={styles.labelStyle}>{label}</span>
      </Button>
    );
  }
}

ActiveFlatButton.propTypes = {
  label: PropTypes.string.isRequired,
};

export default ActiveFlatButton;
